import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { DataService } from 'src/app/data.service';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { UserInfo, UserProfileResponse } from 'src/app/model/user';
import { Subscription } from 'rxjs';
import { ToastrWrapperService } from 'src/app/toastr-wrapper.service';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  imports: [ReactiveFormsModule, MatFormFieldModule, NgIf, MatInputModule, MatButtonModule],
})
export class HomeComponent implements OnInit {
  userId!: string;
  userInfo!: UserInfo;
  loginForm: FormGroup = new FormGroup({});
  loginFormControls!: { [key: string]: AbstractControl };
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private dataService: DataService,
    private toastrService: ToastrWrapperService,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      userId: ['', Validators.required],
    });
    this.loginFormControls = this.loginForm.controls;
  }

  signIn(): Subscription {
    return this.dataService.validateUser(this.loginForm.get('userId')?.value.trim()).subscribe(
      (data: UserProfileResponse) => {
        if (data.status === 200) {
          this.dataService.userInfo = data.body;
          if (
            !(
              this.dataService.userInfo.profile.challengeQuestion1 &&
              this.dataService.userInfo.profile.challengeQuestion2 &&
              this.dataService.userInfo.profile.challengeQuestion3
            )
          ) {
            this.toastrService.showToast(
              'You do not have enough challenge questions set to meet the verification criteria.',
              'Error',
            );
            return;
          }
          this.router.navigate(['question-answer']);
        } else {
          this.toastrService.showToast('Failed to verify the user. Please try again later.', 'Error');
        }
      },
      (error: HttpErrorResponse) => {
        this.toastrService.showToast(
          'Unable to verify account. Please contact support if you have trouble logging in.',
          'Error',
        );
        console.error(error);
      },
    );
  }

  cancel(): void {
    this.document.location.assign(environment.services.idmAppUrl);
  }
}
